import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import moment from "moment";

const EmployeeFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [citizenships, setCitizenships] = useState([]);
  const [positions, setPositions] = useState([]);
  const [identitydocumentTypes, setIdentitydocumentTypes] = useState([]);
  const countryPrefixes = [
    { label: 'US +1', value: '+1' },
    { label: 'RU +7', value: '+7' },
    { label: 'ZA +27', value: '+27' },
    { label: 'GR +30', value: '+30' },
    { label: 'BE +32', value: '+32' },
    { label: 'FR +33', value: '+33' },
    { label: 'ES +34', value: '+34' },
    { label: 'HU +36', value: '+36' },
    { label: 'IT +39', value: '+39' },
    { label: 'RO +40', value: '+40' },
    { label: 'CH +41', value: '+41' },
    { label: 'AT +43', value: '+43' },
    { label: 'GB +44', value: '+44' },
    { label: 'DK +45', value: '+45' },
    { label: 'SE +46', value: '+46' },
    { label: 'NO +47', value: '+47' },
    { label: 'PL +48', value: '+48' },
    { label: 'DE +49', value: '+49' },
    { label: 'MX +52', value: '+52' },
    { label: 'AR +54', value: '+54' },
    { label: 'BR +55', value: '+55' },
    { label: 'CL +56', value: '+56' },
    { label: 'CO +57', value: '+57' },
    { label: 'MY +60', value: '+60' },
    { label: 'AU +61', value: '+61' },
    { label: 'ID +62', value: '+62' },
    { label: 'PH +63', value: '+63' },
    { label: 'NZ +64', value: '+64' },
    { label: 'TH +66', value: '+66' },
    { label: 'JP +81', value: '+81' },
    { label: 'KR +82', value: '+82' },
    { label: 'VN +84', value: '+84' },
    { label: 'CN +86', value: '+86' },
    { label: 'TR +90', value: '+90' },
    { label: 'IN +91', value: '+91' },
    { label: 'PK +92', value: '+92' },
    { label: 'SS +211', value: '+211' },
    { label: 'DZ +213', value: '+213' },
    { label: 'TN +216', value: '+216' },
    { label: 'RW +250', value: '+250' },
    { label: 'IE +353', value: '+353' },
    { label: 'AL +355', value: '+355' },
    { label: 'CY +357', value: '+357' },
    { label: 'FI +358', value: '+358' },
    { label: 'LT +370', value: '+370' },
    { label: 'LV +371', value: '+371' },
    { label: 'EE +372', value: '+372' },
    { label: 'MD +373', value: '+373' },
    { label: 'BY +375', value: '+375' },
    { label: 'UA +380', value: '+380' },
    { label: 'RS +381', value: '+381' },
    { label: 'HR +385', value: '+385' },
    { label: 'SI +386', value: '+386' },
    { label: 'MK +389', value: '+389' },
    { label: 'CZ +420', value: '+420' },
    { label: 'SK +421', value: '+421' },
    { label: 'UY +598', value: '+598' },
    { label: 'HK +852', value: '+852' },
    { label: 'TW +886', value: '+886' },
    { label: 'SA +966', value: '+966' },
    { label: 'AE +971', value: '+971' },
    { label: 'IL +972', value: '+972' }
  ];

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (id) {
      apiCall('patch', '/api/v2/employee/' + id, data)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderEmployeeList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/employee', data)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderEmployeeList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            // history.push('/hr/employee/update/' + response.data.data.id);
            history.push('/hr/employee/read/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/citizenship')
      .then(response => {
        setCitizenships(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/dictionary/identity-document-type')
      .then(response => {
        setIdentitydocumentTypes(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/employee-position')
      .then(response => {
        setPositions(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (id) {
      setLoading(true);
      apiCall('get', '/api/v2/employee/' + id)
        .then(response => {
          const data = response.data.data;
          if (data.birth_day) data.birth_day = new Date(data.birth_day);
          if (data.identity_document_valid_until) data.identity_document_valid_until = new Date(data.identity_document_valid_until);
          setFormData(data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"employee-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="last_name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="last_name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldLastName')}</label>
                  <span className="p-d-block">
                      <InputText id="last_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     last_name: e.target.value
                                   })
                                 }}
                                 value={formData.last_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="first_name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="first_name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldFirstName')}</label>
                  <span className="p-d-block">
                      <InputText id="first_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     first_name: e.target.value
                                   })
                                 }}
                                 value={formData.first_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="employee_position" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="employee_position"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPosition')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(positions, "name")}
                               id={"employee_position"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noEmployeePosition')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   employee_position: e.value
                                 })
                               }}
                               value={formData?.employee_position?.id ?? formData.employee_position ?? null}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-6">
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="email" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmail')}</label>
                  <span className="p-d-block">
          <InputText id="email" {...input} value={formData.email}
                     onChange={(e) => setFormData({...formData, email: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className="p-col-12 p-lg-6">
              <Field name="insurance_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="insurance_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldInsuranceNumber')}</label>
                  <span className="p-d-block">
          <InputText id="insurance_number" {...input} value={formData.insurance_number}
                     onChange={(e) => setFormData({...formData, insurance_number: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-6">
              <Field name="tax_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="tax_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldVatNumber')}</label>
                  <span className="p-d-block">
          <InputText id="tax_number" {...input} value={formData.tax_number}
                     onChange={(e) => setFormData({...formData, tax_number: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className="p-col-12 p-lg-4">
              <Field name="identity_document_type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="identity_document_type" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIdentityDocumentType')}</label>
                  <span className="p-d-block">
          <Dropdown id="identity_document_type" {...input} value={formData.identity_document_type}
                     options={window.App.sortDropdownOptions(identitydocumentTypes, "value")} optionValue={"key"} optionLabel={"value"} placeholder={t('selectPlaceholder')}
                     onChange={(e) => setFormData({...formData, identity_document_type: e.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-4">
              <Field name="identity_document_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="identity_document_number" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIdentityDocumentNumber')}</label>
                  <span className="p-d-block">
          <InputText id="identity_document_number" {...input} value={formData.identity_document_number}
                     onChange={(e) => setFormData({...formData, identity_document_number: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-4">
              <Field name="identity_document_valid_until" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="identity_document_valid_until"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIdentityDocumentValidUntil')}</label>
                  <span className="p-d-block">
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"date"}
                                 mask={"9999-99-99"}
                                 placeholder={t('datePlaceholder')}
                                 value={moment.utc(formData.identity_document_valid_until).local().format('YYYY-MM-DD')}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       identity_document_valid_until: new Date(e.value)
                                     })
                                   }
                                 }}
                      />
                      <Calendar value={formData.identity_document_valid_until}
                                locale="hu"
                                dateFormat={'yy-mm-dd'}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    identity_document_valid_until: e.value
                                  })
                                }}/>
                    </div>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className="p-col-12 p-lg-3">
              <Field name="phone_country_code" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                      <label htmlFor="phone_country_code" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldPhoneCountryCode')}</label>
                      <span className="p-d-block">
                          <Dropdown 
                              id="phone_country_code" 
                              value={formData.phone_country_code}
                              options={countryPrefixes} 
                              onChange={(e) => setFormData({ ...formData, phone_country_code: e.value })}
                              filter
                              placeholder={t('selectPlaceholder')} 
                              className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                          />
                      </span>
                      {getFormErrorMessage(meta)}
                  </div>
              )} />
          </div>
            <div className="p-col-12 p-lg-2">
              <Field name="phone_area_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="phone_area_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPhoneAreaCode')}</label>
                  <span className="p-d-block">
          <InputText id="phone_area_code" {...input} value={formData.phone_area_code}
                     onChange={(e) => setFormData({...formData, phone_area_code: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-5">
              <Field name="phone_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="phone_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPhoneNumber')}</label>
                  <span className="p-d-block">
          <InputText id="phone_number" {...input} value={formData.phone_number}
                     onChange={(e) => setFormData({...formData, phone_number: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-2">
              <Field name="phone_suffix" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="phone_suffix"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPhoneSuffix')}</label>
                  <span className="p-d-block">
          <InputText id="phone_suffix" {...input} value={formData.phone_suffix}
                     onChange={(e) => setFormData({...formData, phone_suffix: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className="p-col-12 p-lg-4">
              <Field name="birth_place" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="birth_place" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldBirthPlace')}</label>
                  <span className="p-d-block">
          <InputText id="birth_place" {...input} value={formData.birth_place}
                     onChange={(e) => setFormData({...formData, birth_place: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-4">
              <Field name="birth_day" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="birth_day" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldBirthDay')}</label>
                  <span className="p-d-block">
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"date"}
                                 mask={"9999-99-99"}
                                 placeholder={t('datePlaceholder')}
                                 value={moment.utc(formData.birth_day).local().format('YYYY-MM-DD')}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       birth_day: new Date(e.value)
                                     })
                                   }
                                 }}
                      />
                      <Calendar value={formData.birth_day}
                                locale="hu"
                                dateFormat={'yy-mm-dd'}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    birth_day: e.value
                                  })
                                }}/>
                    </div>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-4">
              <Field name="citizenship" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="citizenship"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCitizenship')}</label>
                  <span className="p-d-block">
                    <Dropdown options={window.App.sortDropdownOptions(citizenships, "name")}
                              id={"citizenship"}
                              optionValue={"id"}
                              optionLabel={"name"}
                              emptyMessage={t('noCitizenship')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  citizenship: e.value
                                })
                              }}
                              value={formData?.citizenship?.id || formData.citizenship}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className="p-col-12 p-lg-12">
              <Field name="bank_account" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="bank_account"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldBankAccount')}</label>
                  <span className="p-d-block">
          <InputText id="bank_account" {...input} value={formData.bank_account}
                     onChange={(e) => setFormData({...formData, bank_account: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-12">
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
          <InputText id="note" {...input} value={formData.note}
                     onChange={(e) => setFormData({...formData, note: e.target.value})}
                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'employee' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(EmployeeFormComponent);
